<template>
	<form class="order-form" id="register" action="#" @submit.prevent="submit">
		<!-- <div class="input-cont"> -->
		<!-- <div> -->
		<!-- <div> -->
		<InputBox
			labelValue="First Name"
			placeHolder="First Name"
			inputStyleType="sharp"
			v-model="formData.firstName"
			:readonly="!isFieldEditable"
			required
		/>
		<InputBox
			labelValue="Last Name"
			placeHolder="Last Name"
			inputStyleType="sharp"
			v-model="formData.lastName"
			:readonly="!isFieldEditable"
			required
		/>
		<InputBox
			labelValue="Email"
			placeHolder="Email"
			inputStyleType="sharp"
			v-model="formData.email"
			type="email"
			:readonly="isConfirmPage"
			required
		/>
		<InputBox
			labelValue="Phone"
			placeHolder="Phone"
			inputStyleType="sharp"
			v-model="formData.phone"
			:readonly="!isFieldEditable"
			required
			type="tel"
			v-mask="['(###) ###-####']"
		/>
		<InputBox
			v-if="isConfirmPage === false"
			labelValue="Password"
			placeHolder="Password"
			inputStyleType="sharp"
			v-model="formData.password"
			type="password"
			required
		/>
		<!-- </div> -->
		<!-- <div> -->
		<InputBox
			labelValue="Address"
			placeHolder="Address"
			inputStyleType="sharp"
			v-model="formData.address"
			:readonly="true"
			required
			contClass="form-address"
		/>
		<InputBox
			labelValue="PIN"
			placeHolder="PIN"
			inputStyleType="sharp"
			v-model="formData.pin"
			:readonly="true"
			required
			contClass="form-password"
		/>
		<div v-if="isConfirmPage" class="paragraph question">Did you purchase home in the last three years?</div>
		<div class="radio-cont" v-if="isConfirmPage">
			<input type="radio" id="homeYes" value="Yes" v-model="formData.homePurchased" />
			<label for="Yes">Yes</label>
			<input type="radio" id="homeNo" value="No" v-model="formData.homePurchased" />
			<label for="No">No</label>
		</div>
		<div v-if="formData.homePurchased == 'Yes'" class="extra-q-cont">
			<div class="sharp input-box date-pick-sec">
				<datetime
					class="date-input"
					:flow="['year', 'month', 'date']"
					:max-datetime="maxDate"
					v-model="formData.purchaseDate"
					placeholder="Purchase Date"
					auto
				></datetime>
				<i class="material-icons">today</i>
			</div>
			<InputBox placeHolder="Purchase Amount" inputStyleType="sharp" v-model="formData.purchaseAmount" />
		</div>
		<!-- </div> -->
		<!-- </div> -->
	</form>
</template>

<script>
import InputBox from "@/components/ui/InputBox.vue";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import api from "@/store/utils/api";
// https://github.com/vuejs-tips/vue-the-mask
import { mask } from "vue-the-mask";

export default {
	name: "order-form",
	directives: { mask },
	props: ["isConfirm"],
	mounted() {
		console.log("this.$store.getters.getOrderForm", this.formData);
	},
	components: {
		InputBox,
		datetime: Datetime,
	},
	methods: {
		clear() {
			document.getElementById("register").reset();
		},
	},
	computed: {
		isFieldEditable() {
			if (this.isConfirm) return this.$store.getters.getOrderFormEditable;
			return true;
		},
		isConfirmPage() {
			if (this.isConfirm) return true;
			return false;
		},
		formData() {
			return this.$store.getters.getOrderForm;
		},
		maxDate() {
			const date = new Date(Date.now());
			return date.toISOString();
		},
	},
};
</script>

<style scoped lang="scss">
.order-form {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
	// grid-gap: 1rem;
	column-gap: 1rem;
	@media (min-width: 1368px) {
		.form-address {
			grid-row-start: 1;
			grid-row-end: 2;
			grid-column-start: 3;
			grid-column-end: 4;
		}
		.form-password {
			grid-row-start: 2;
			grid-row-end: 3;
			grid-column-start: 3;
			grid-column-end: 4;
		}
	}
}
#register.order-form {
	margin-bottom: 35px;
	.header5 {
		color: var(--accent);
	}
	.header3 {
		font-size: 36px;
		line-height: 36px;
		color: var(--black);
		margin-top: 8px;
	}
	.question {
		color: rgba(22, 22, 22, 0.5);
		margin-top: 2px;
	}
	.radio-cont {
		margin-top: 11px;
		// margin-bottom: 7px;
		margin-bottom: 33px;
	}
	// .input-cont {
	// 	max-width: 1200px;
	// 	grid-column-gap: 10px;
	// 	margin-top: 60px;
	// 	display: grid;
	// 	grid-template-columns: 1fr 1fr;

	@media only screen and (max-width: 800px) {
		grid-template-columns: 1fr;
	}

	.sharp.input-box {
		margin: 5px auto;
	}
	.extra-q-cont {
		.sharp.input-box.date-pick-sec {
			display: flex;
			flex-direction: row;
			align-items: center;
			.vdatetime.date-input {
				position: relative;
				display: flex;
			}
			i.material-icons {
				margin-left: 10px;
			}
		}
		// .sharp.input-box:last-child {
		// 	margin-top: 15px;
		// }
	}
	input[placeholder="address"],
	input[placeholder="PIN"] {
		padding-left: 0 !important;
	}
	// }
	.button-cont {
		display: flex;
		flex-direction: row;
		// margin-top: 55px;
		.button {
			margin: 0 10px;
		}
	}
}
</style>
